(() => {
  document.querySelectorAll('[data-pino-compact-menu]').forEach(menu => {
    if (menu.dataset.compactInitialized) return;
    menu.dataset.compactInitialized = 'true';
    menu.querySelectorAll('[data-pino-compact-accordion]').forEach(accordion => {
      const summary = accordion.querySelector(':scope > summary');
      const syncExpanded = () => summary?.setAttribute('aria-expanded', String(accordion.open));
      syncExpanded();
      accordion.addEventListener('toggle', syncExpanded);
    });
    menu.addEventListener('click', event => {
      const summary = event.target.closest('[data-pino-compact-accordion] > summary');
      if (summary && menu.contains(summary)) {
        event.stopPropagation();
        return;
      }
      const closeButton = event.target.closest('[data-pino-menu-close]');
      if (!closeButton || !menu.contains(closeButton)) return;
      const details = menu.closest('details');
      if (!details) return;
      details.open = false;
      const trigger = details.querySelector(':scope > summary');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }, true);
    menu.addEventListener('keyup', event => {
      if (event.key !== 'Escape') return;
      const accordion = event.target.closest('[data-pino-compact-accordion][open]');
      if (!accordion || !menu.contains(accordion)) return;
      accordion.open = false;
      const summary = accordion.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
      event.stopPropagation();
      event.preventDefault();
    }, true);
  });
})();
